import React, { useRef } from "react";
import Slider from "react-slick";
import arrow11 from "../assets/pictures/arrows.png";
import useShowOscarFilmFest from "../customHooks/useShowOscarFilmFest";
import { useHistory } from "react-router-dom";
import { getGumletUrl } from "../assets/gumlet/gumlet.js";
import { LanguageService } from "../ApiServices/tokenService.js";

const isRTL = LanguageService.getLanguage() === "ar";

const NewBanner = ({ banners }) => {
  const showOscarFilmFest = useShowOscarFilmFest();
  const history = useHistory();
  const sliderRef = useRef(null);

  const handleBannerRedirecton = (ID, banner) => {
    if (!banner.redirect_url) {
      if (banner.ID) history.push(`/movies/${banner.ID}`);
      else if (banner.banner_title === "Event") history.push(`/book-event`);
      else history.push(`/movies-list`);
    } else {
      history.push(banner.redirect_url);
    }
  };

  const handleNext = () => {
    if (isRTL) {
      sliderRef.current?.slickPrev(); // RTL: move left
    } else {
      sliderRef.current?.slickNext(); // LTR: move right
    }
  };

  const handlePrev = () => {
    if (isRTL) {
      sliderRef.current?.slickNext(); // RTL: move right
    } else {
      sliderRef.current?.slickPrev(); // LTR: move left
    }
  };

  const ArrowButton = ({ direction }) => {
    const isNext = direction === "next";

    const offsetPercentage = "19%"; // You can tweak this value

    const positionStyle = {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 10,
      [isNext ? (isRTL ? "left" : "right") : isRTL ? "right" : "left"]:
        offsetPercentage,
    };

    const rotate =
      (isNext && isRTL) || (!isNext && !isRTL) ? "rotate(180deg)" : "";

    return (
      <div onClick={isNext ? handleNext : handlePrev} style={positionStyle}>
        <img
          src={arrow11}
          alt={`${direction} arrow`}
          style={{
            width: "50px",
            height: "50px",
            border: "2px solid white",
            borderRadius: "50%",
            cursor: "pointer",
            transform: rotate,
          }}
        />
      </div>
    );
  };

  const heroSlider1 = {
    slidesToShow: 1,
    centerMode: true,
    dots: true,
    infinite: true,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnFocus: false,
    pauseOnHover: false,
    variableWidth: true,
    arrows: false,
  };

  return (
    <div className="slider-container px-0" style={{ position: "relative" }}>
      <ArrowButton direction="prev" />
      <ArrowButton direction="next" />
      <Slider ref={sliderRef} {...heroSlider1} className="m-0 p-0">
        {banners &&
          banners
            .filter((banner) => {
              if (!showOscarFilmFest) {
                if (
                  banner.banner_title &&
                  banner.banner_title
                    .toLowerCase()
                    .includes("oscar film festival")
                ) {
                  return false;
                }
              }
              if (banner.m_banner_type === "popup_promotion") return false;
              return true;
            })
            .map((banner, index) => (
              <div
                onClick={() => handleBannerRedirecton(banner.ID, banner)}
                key={index}
                style={{ margin: "0", padding: "0" }}
              >
                <div
                  className="banner-hero"
                  style={{ margin: "0", padding: "0" }}
                >
                  <div
                    className={`banner-hero-img ${
                      banner.show_advanced_booking_tag === "Y"
                        ? "advance-lg"
                        : ""
                    } ${banner.m_banner_type === "promotion" ? "img-fit" : ""}`}
                  >
                    <figure
                      style={{ margin: "0", padding: "0" }}
                      className="banner-hero-img"
                    >
                      <img
                        style={{ width: "880px" }}
                        className="img-fluid"
                        src={banner.m_banner_image_url_1}
                        alt="banner_img"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            ))}
      </Slider>
    </div>
  );
};

export default NewBanner;
